import React from 'react';
//import { render } from 'react-dom';
import { Map, Marker, Popup, TileLayer } from 'react-leaflet';



const ChargerMap = ((props) => {
  const { cityCoordinates, chargers, distance } = props;
  let zoom = 14 - distance * (0.5)

  return (
    < Map className='map' center={cityCoordinates.coordinates} zoom={zoom} >
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution="&copy; <a href='http://osm.org/copyright'>OpenStreetMap</a> contributors"
      />
      {chargers.map(charger => (
        < Marker key={charger.ID} position={[charger.AddressInfo.Latitude, charger.AddressInfo.Longitude]}>
          <Popup>
            <span>Charger Location: {charger.AddressInfo.Title}</span>
          </Popup>
        </Marker>
      ))}
    </Map >
  )
});

export default ChargerMap;